import { Wallet } from "lucide-react";
import { fmtUSD } from "@/lib/money";

export const BalanceCard = ({ balance }) => {
  const low = balance && balance.auto_refill_enabled && balance.credits < balance.auto_refill_threshold;
  return (
    <div className="border border-border bg-[#0A0A0A] rounded-sm p-6">
      <div className="flex items-center gap-2 text-muted-foreground mb-2">
        <Wallet className="w-4 h-4" />
        <span className="text-[10px] uppercase tracking-[0.25em] font-bold">Available balance</span>
      </div>
      <p className={`font-mono text-4xl font-bold ${balance && balance.credits < 0 ? "text-red-400" : ""}`} data-testid="credits-balance">
        {balance === null ? "…" : fmtUSD(balance.credits)}
      </p>
      {low && (
        <p className="text-xs text-amber-400 mt-2" data-testid="low-balance-warning">
          Balance is below your {fmtUSD(balance.auto_refill_threshold)} auto-refill trigger.
        </p>
      )}
    </div>
  );
};
